import { Card, createTheme, type MantineTheme } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const ThemedMantineCard: PartialDeep<MantineTheme> = createTheme({
  components: {
    Card: Card.extend({
      defaultProps: {
        withBorder: true,
      },
      styles: theme => ({
        root: {
          borderColor: theme.colors.gray[2],
        },
      }),
    }),
  },
});
